module.exports = __webpack_public_path__ + "static/media/feature-recommedation-setting.69736f03.png";